export default {
    homePage_00081: 'Dashboard',
    homePage_00066: 'HomePage overview',
    homePage_00001: 'Charger Status',
    homePage_00002: 'Net Zero Status',
    homePage_00003: 'Available',
    homePage_00004: 'In-use',
    homePage_00005: 'Error/Offline',
    homePage_00006: 'Charging',
    homePage_00007: 'Discharging',
    homePage_00008: 'Faulty',
    homePage_00009: 'Revenue (Today)',
    homePage_00010: 'Electricity sold (Today)',
    homePage_00011: 'Users (Yesterday)',
    homePage_00012: 'Revenue',
    homePage_00013: 'Energy',
    homePage_00014: 'Users',
    homePage_00015: 'Last Week',
    homePage_00016: 'Last Month',
    homePage_00017: 'First-Time Users',
    homePage_00018: 'Charging Users',
    homePage_00019: 'Utilization',
    homePage_00020: 'DC',
    homePage_00021: 'AC',
}